<!--工作室概况-->
<template>
    <div class="content-container">
        <!--左侧：新闻资讯、轮播、工作室、成果展示-->
        <div class="main-column">
            <!--新闻资讯 + 轮播（高度与关注度排行卡片一致）-->
            <div class="studio-top" :style="{height: topRowHeight + 'px'}">
                <div class="card studio-news-list">
                    <div class="sec-title">
                        <div class="bar"></div>
                        <div class="name">新闻资讯</div>
                        <div class="more" v-if="newsList&&newsList.length>newsShowCount" @click="openNewsDialog()">查看更多>></div>
                    </div>
                    <div class="news-list-box">
                        <div class="news-one" v-for="item in newsList.slice(0,newsShowCount)" :key="item" @click="handleViewNews(item, '0')">
                            {{item.title}}
                        </div>
                        <dataEmpty v-if="newsList&&newsList.length===0" title="暂无新闻资讯"/>
                    </div>
                </div>
                <div class="studio-news">
                    <el-carousel :interval="3000" arrow="always" height="100%">
                        <el-carousel-item class="carousel-item" v-for="item in newsList" :key="item" @click="handleViewNews(item, '0')">
                            <img class="top-img" :src="item.cover" alt="">
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <!--工作室-->
            <div class="card">
                <div class="sec-title">
                    <div class="bar"></div>
                    <div class="name">{{studioNature==='2'?'名师工作室':'名校长工作室'}}</div>
                    <div class="more" v-if="studioList&&studioList.length>0" @click="goToStudioList('2')">查看更多>></div>
                </div>
                <div class="studio-box">
                    <div class="studio-one" @click="viewStudioDetail(item)" v-for="item in studioList.slice(0,5)" :key="item">
                        <div class="studio-cover">
                            <img class="studio-cover-img"  :src="item.groupAvatar" alt />
                        </div>
                        <div class="studio-name">{{item.groupName}}</div>
                    </div>
                    <data-empty v-if="studioList&&studioList.length===0" title="暂无工作室"/>
                </div>
            </div>
            <!--成果展示-->
            <div class="card">
                <div class="sec-title">
                    <div class="bar"></div>
                    <div class="name">成果展示</div>
                    <div class="more" v-if="achieveList&&achieveList.length>0"  @click="goToStudioList('3')">查看更多>></div>
                </div>
                <div class="achieve-box">
                    <div class="achieve-item" v-for="item in achieveList.slice(0,4)" :key="item" @click="viewAchieveDetail(item)">
                        <div class="achieve-cover">
                            <img class="img-100"  :src="item.cover" alt />
                        </div>
                        <div class="achieve-name">{{item.title}}</div>
                    </div>
                    <data-empty v-if="achieveList&&achieveList.length===0" title="暂无成果"/>
                </div>
            </div>
        </div>
        <!--右侧：关注度排行、工作室动态-->
        <div class="side-column">
            <!--关注度排行-->
            <div class="card">
                <div class="sec-title">
                    <div class="bar"></div>
                    <div class="name">关注度排行</div>
                    <div class="more" v-if="studioList&&studioList.length>0" @click="goToStudioList('2')">查看更多>></div>
                </div>
                <div class="rank-list">
                    <div class="rank-one" v-for="(item,index) in studioList.slice(0,10)" :key="item" @click="viewStudioDetail(item)">
                        <div class="rank-badge" :class="'r'+(index+1)">{{index+1}}</div>
                        <div class="rank-name">{{item.groupName}}</div>
                        <div class="rank-care"><span>{{item.careNum}}</span>人关注</div>
                    </div>
                    <data-empty v-if="studioList&&studioList.length===0" title="暂无数据"/>
                </div>
            </div>
            <!--工作室动态-->
            <div class="card">
                <div class="sec-title">
                    <div class="bar"></div>
                    <div class="name">工作室动态</div>
                    <div class="more" v-if="articleList&&articleList.length>0" @click="openTrendDialog()">查看更多>></div>
                </div>
                <div class="trend-list">
                    <div class="trend-one" v-for="(item,index) in articleList.slice(0,10)" :key="item" @click="handleViewStudioNews(item)">
                        <div class="trend-tag hot" v-if="index<2">最热</div>
                        <div class="trend-tag new" v-else-if="index===2">最新</div>
                        <div class="trend-name">{{item.title}}</div>
                        <div class="trend-belong">{{item.groupName}}</div>
                    </div>
                    <data-empty v-if="articleList&&articleList.length===0" title="暂无动态"/>
                </div>
            </div>
        </div>
        <!--工作室动态弹窗（分页展示全部动态）-->
        <el-dialog v-model="trendDialogVisible" title="工作室动态" width="720px">
            <div class="trend-dialog-list">
                <div class="trend-dialog-one" v-for="item in trendPageList" :key="item.infoId" @click="handleViewStudioNews(item)">
                    <div class="trend-name">{{item.title}}</div>
                    <div class="trend-belong">{{item.groupName}}</div>
                    <div class="trend-time">{{timestampToTime(item.createTime)}}</div>
                </div>
                <data-empty v-if="!articleList||articleList.length===0" title="暂无动态"/>
            </div>
            <div class="trend-page-box" v-if="articleList&&articleList.length>trendPageSize">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :total="articleList.length"
                    :page-size="trendPageSize"
                    :current-page="trendPage"
                    @current-change="handleTrendPageChange">
                </el-pagination>
            </div>
        </el-dialog>
        <!--新闻资讯弹窗（分页展示全部新闻）-->
        <el-dialog v-model="newsDialogVisible" title="新闻资讯" width="720px">
            <div class="trend-dialog-list">
                <div class="trend-dialog-one" v-for="item in newsPageList" :key="item.newsId" @click="handleViewNews(item, '0')">
                    <div class="trend-name">{{item.title}}</div>
                    <div class="trend-time">{{timestampToTime(item.releaseTime||item.createTime)}}</div>
                </div>
                <data-empty v-if="!newsList||newsList.length===0" title="暂无新闻资讯"/>
            </div>
            <div class="trend-page-box" v-if="newsList&&newsList.length>newsPageSize">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :total="newsList.length"
                    :page-size="newsPageSize"
                    :current-page="newsPage"
                    @current-change="handleNewsPageChange">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import {studioTeacherState,studioHeadmasterState} from "@/api/admin/studio";
import {timestampToTime} from "@/utils/date";

export default {
    name:'studioOverview',
    components:{dataEmpty},
    props:{
        studioNature:{
            type: String,
            default:"2"
        },
    },
    watch:{},
    mounted() {
        if (this.studioNature==='2'){
            this.selectTeaStudioState();
        }
        if (this.studioNature==='3'){
            this.selectRectorStudioState();
        }

    },
    updated() {},
    data() {
        return {
            //概览
            studioState:{},
            studioList: [],// 工作室列表
            articleList: [],// 教师文章
            achieveList:[],//成果
            newsList:[],//新闻资讯
            topRowHeight: 320,// 新闻资讯+轮播行高度（与关注度排行卡片一致）
            newsShowCount: 6,// 当前高度下可展示的新闻条数
            timestampToTime,
            trendDialogVisible: false,// 工作室动态弹窗
            trendPage: 1,// 弹窗当前页
            trendPageSize: 10,// 弹窗每页条数
            newsDialogVisible: false,// 新闻资讯弹窗
            newsPage: 1,// 新闻弹窗当前页
            newsPageSize: 10,// 新闻弹窗每页条数
        }
    },
    computed: {
        /*工作室动态弹窗当前页数据*/
        trendPageList(){
            const start = (this.trendPage-1)*this.trendPageSize;
            return (this.articleList||[]).slice(start, start+this.trendPageSize);
        },
        /*新闻资讯弹窗当前页数据*/
        newsPageList(){
            const start = (this.newsPage-1)*this.newsPageSize;
            return (this.newsList||[]).slice(start, start+this.newsPageSize);
        },
    },
    methods: {
        /*打开工作室动态弹窗*/
        openTrendDialog(){
            this.trendPage = 1;
            this.trendDialogVisible = true;
        },
        /*弹窗翻页*/
        handleTrendPageChange(page){
            this.trendPage = page;
        },
        /*打开新闻资讯弹窗*/
        openNewsDialog(){
            this.newsPage = 1;
            this.newsDialogVisible = true;
        },
        /*新闻弹窗翻页*/
        handleNewsPageChange(page){
            this.newsPage = page;
        },
        selectTeaStudioState() {
            studioTeacherState().then(res => {
                this.studioState = res.data.data;
                this.studioList = this.studioState.studioList;
                this.articleList = this.studioState.jswzList;
                this.achieveList = this.studioState.cgzsList;
                this.newsList = this.studioState.newsList;
                this.computeTopRowHeight();
            })
        },
        selectRectorStudioState(){
            studioHeadmasterState().then(res => {
                this.studioState = res.data.data;
                this.studioList = this.studioState.studioList;
                this.articleList = this.studioState.jswzList;
                this.achieveList = this.studioState.cgzsList;
                this.newsList = this.studioState.newsList;
                this.computeTopRowHeight();
            })
        },
        //新闻资讯+轮播行高度与关注度排行卡片保持一致：标题46+标题下边距10+卡片底内边距16+行高36*行数
        computeTopRowHeight(){
            const count = this.studioList && this.studioList.length ? this.studioList.length : 0;
            const rows = Math.min(Math.max(count, 3), 6);
            this.topRowHeight = 72 + rows * 36;
            this.newsShowCount = Math.max(1, Math.floor((this.topRowHeight - 72) / 36));
        },
        viewStudioDetail(s){
            let path = 'teachStudioHome';
            if (this.studioNature==='3'){
                path = 'rectorStudioHome';
            }
            //参数传递
            this.$store.commit("params/setJumpParams",
              {activePath:path,activeItem: '1',studioId:s.groupId,studioNature:this.studioNature});
            this.$router.push({path: "/hyedu/studiodetail"});
        },
        handleViewNews(item,type){
            let itemId = '';
            if (type==='1'){
                itemId = item.bannerId;
            }
            if (type==='0'){
                itemId = item.newsId;
            }
            //参数传递
            let routeUrl = this.$router.resolve({
                path: "/hyedu/news",
                query: {
                    signno: itemId,
                    type:type
                }
            });
            window.open(routeUrl.href, '_blank')
        },
        goToStudioList(type){
            this.$emit('change-parent-item',type);
        },
        viewAchieveDetail(item){
            console.log("成果详情："+item.infoId)
            this.$store.commit("params/setJumpParams", {infoId:item.infoId});
            this.$emit('change-parent-item','3');

        },
        handleViewStudioNews(item){
            //参数传递
            let routeUrl = this.$router.resolve({
                path: "/hyedu/studionews",
                query: {
                    signno: item.infoId,
                }
            });
            window.open(routeUrl.href, '_blank')
        },
    }
}

</script>

<style scoped>
.content-container{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    gap: 16px;
    align-items: flex-start;
}
/*左右两栏*/
.main-column{
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.side-column{
    width: 400px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
}
/*卡片*/
.card{
    background: #fff;
    border-radius: 16px;
    box-sizing: border-box;
    padding: 0 16px 16px;
}
/*区块标题栏*/
.sec-title{
    display: flex;
    align-items: center;
    height: 46px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 10px;
    .bar{
        width: 4px;
        height: 16px;
        background: #0d55a4;
        border-radius: 2px;
        margin-right: 8px;
    }
    .name{
        font-size: 16px;
        font-weight: bold;
        color: #333;
    }
    .more{
        margin-left: auto;
        font-size: 14px;
        color: #29b7f0;
        cursor: pointer;
    }
    .more:hover{
        color: #0d55a4;
    }
}
/*第一行：新闻资讯 + 轮播（高度由 topRowHeight 内联控制，与关注度排行一致）*/
.studio-top{
    display: flex;
    gap: 16px;
}
.studio-news-list{
    flex: 1;
    min-width: 0;
    overflow: hidden;
}
.news-one{
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    color: #333;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.news-one:hover{
    color: #0d55a4;
}
.studio-news{
    width: 46%;
    flex-shrink: 0;
    border-radius: 16px;
    overflow: hidden;
    background: #fff;
}
/deep/ .studio-news .el-carousel{
    width: 100%;
    height: 100%;
}
.carousel-item{
    width: 100%;
    height: 100%;
    cursor: pointer;
    img{
        width: 100%;
        height: 100%;
    }
}
/deep/ .studio-news .el-carousel .el-carousel-item img{
    width: 100%;
    height: 100%;
}
.top-img{
    width: 100%;
    height:100%;
}
/*指示器按钮*/
/deep/ .el-carousel__button {
    width: 8px;
    height: 8px;
    border: none;
    border-radius: 50%;
    background-color: grey;
}
/*工作室*/
.studio-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}
.studio-one{
    width: 20%;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.studio-cover{
    width: 100%;
    height: 110px;
}
.studio-cover-img{
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.studio-name{
    width: 100%;
    margin-top: 8px;
    color: #333;
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
}
/*成果展示*/
.achieve-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}
.achieve-item{
    width: 50%;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.achieve-cover{
    width: 100%;
    height: 220px;
    border-radius: 8px;
    overflow: hidden;
    img{
        width: 100%;
        height: 100%;
    }
}
.achieve-name{
    width: 100%;
    margin-top: 8px;
    color: #333;
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/*关注度排行*/
.rank-one{
    display: flex;
    align-items: center;
    height: 44px;
    cursor: pointer;
}
.rank-badge{
    width: 22px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    border-radius: 6px;
    color: #fff;
    font-size: 13px;
    margin-right: 10px;
    background: #c0c4cc;
    flex-shrink: 0;
}
.rank-badge.r1{
    background: #f56c6c;
}
.rank-badge.r2{
    background: #409eff;
}
.rank-badge.r3{
    background: #e6a23c;
}
.rank-name{
    flex: 1;
    min-width: 0;
    font-size: 15px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.rank-care{
    flex-shrink: 0;
    font-size: 14px;
    color: #999;
    span{
        color: #f56c6c;
    }
}
/*工作室动态*/
.trend-one{
    display: flex;
    align-items: center;
    height: 46px;
    cursor: pointer;
}
.trend-tag{
    flex-shrink: 0;
    height: 20px;
    line-height: 20px;
    padding: 0 6px;
    border-radius: 4px;
    font-size: 12px;
    color: #fff;
    margin-right: 8px;
}
.trend-tag.hot{
    background: #f56c6c;
}
.trend-tag.new{
    background: #409eff;
}
.trend-name{
    flex: 1;
    min-width: 0;
    font-size: 15px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.trend-name:hover{
    color: #0d55a4;
}
.trend-belong{
    width: 120px;
    flex-shrink: 0;
    text-align: right;
    color: #999;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/*工作室动态弹窗*/
.trend-dialog-list{
    min-height: 200px;
}
.trend-dialog-one{
    display: flex;
    align-items: center;
    height: 44px;
    border-bottom: 1px dashed #eee;
    cursor: pointer;
}
.trend-dialog-one:hover .trend-name{
    color: #0d55a4;
}
.trend-dialog-one .trend-time{
    width: 140px;
    flex-shrink: 0;
    text-align: right;
    color: #999;
    font-size: 13px;
    margin-left: 12px;
}
.trend-page-box{
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
}
</style>